module.exports = __webpack_public_path__ + "static/media/destacados-1.ceae48c7.png";